var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:{open: _vm.isOpen},attrs:{"id":"menu"}},[_c('ul',_vm._l((_vm.menuItems),function(item,index){return _c('MenuItem',{key:index,attrs:{"to":item.to,"text":item.text}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }